module.exports = __webpack_public_path__ + "static/318503382_666026165193822_1805355563868328223_n.jpg-1671186393568-97d3256fe6e17a01d36dd97c95c94a54.webp";